<template>
  <!-- Point d'entrée de l'appli -->
  <v-app>
    <SpinnerLoading v-if="global_loading"></SpinnerLoading>
 
    <div v-if="mainStore.module.isLoaded && !global_loading">
      <TheHeader></TheHeader>
      <router-view />
      <NotificationSystem></NotificationSystem>
      <v-snackbar v-model="show_snackbar_vip_not_valid">
        {{ status_vip }}
        <template v-slot:actions>
          <v-btn color="primary-dark" variant="text" @click="show_snackbar_vip_not_valid = false"> Fermer </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>
// @ is an alias to /src
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import { useBookingStore } from './stores/bookingStore';
import TheHeader from "@/components/App/TheHeader.vue";
import NotificationSystem from "@/components/App/NotificationSystem.vue";
import SpinnerLoading from "@/components/App/SpinnerLoading.vue";

export default {
  components: {
    TheHeader,
    NotificationSystem,
    SpinnerLoading,
  },
  data() {
    return {
      global_loading: false,
      show_snackbar_vip_not_valid: false,
      status_vip: "",
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  watch: {
    "mainStore.module.nom": function () {
      document.title = this.mainStore.module.nom + " | Inscriptions Sportips";
    },
    "$route.params.base_module": function () {

      this.init();


    },
  },
  methods: {

    async init() {
      const base_module = this.$route.params.base_module;
      await this.mainStore.initializeApp(base_module);
      if (!this.mainStore.billetterie_mode) {
        this.bookingStore.initializeFromLocalStorage();
      }



    },
    check_inscription_vip_validity() {
      if (!this.mainStore.inscription_vip) return;
      this.status_vip = this.mainStore.inscription_vip.get_status();
      if (!this.mainStore.inscription_vip.token) {
        this.mainStore.inscription_vip = null;
        return;
      }
      if (!this.mainStore.inscription_vip.id || !this.mainStore.inscription_vip.is_valid()) {
        this.mainStore.inscription_vip = null;
        this.show_snackbar_vip_not_valid = true;
        return;
      }
    },
  },

  async mounted() {
    this.global_loading = true;
    await this.init();
    await this.mainStore.init_inscription_vip(this.$route.query.code_acces);
    await this.mainStore.init_inscription_vip_multi_usage(this.$route.query.code_privilege);

    this.check_inscription_vip_validity();
    this.global_loading = false;
  },

};
</script>

<style lang="scss">
@import "@/assets/scss/Global.scss";
</style>
